import { Dispatch } from "redux";
import { thinkApi } from "../../Api/Microservices";
import {
  FETCH_ANNOUNCEMENTS_FAILURE,
  FETCH_ANNOUNCEMENTS_REQUEST,
  FETCH_ANNOUNCEMENTS_SUCCESS,
  FETCH_INDEXES_FAILURE,
  FETCH_INDEXES_REQUEST,
  FETCH_INDEXES_SUCCESS,
  SET_DEFAULT_INDEXES,
  SET_INDEX_KEY_AND_VALUE,
  SET_INDEXES,
  SET_SELECTED_INDEX,
  SET_SELECTED_SUB_INDEX,
  UPDATE_HEADER_INDEX_KEY_AND_VALUE,
  SET_DEEPSEARCH_MODE,
  SET_DEEPSEARCH_MODE_FALSE,
  SET_USE_ONLY_EXTERNAL_DOCUMENTS,
  SET_USE_ONLY_EXTERNAL_DOCUMENTS_FALSE,
  HAS_EXTERNAL_UPLOADED_DOCUMENTS,
} from "./DashboardTypes";
import { IndexGroup } from "../../Models/Indexes";
import { buildAppError } from "../../Utils/AppError";

const setAuthorizationHeader = (token: any) => {
  thinkApi.defaults.headers.common["Authorization"] = `Bearer ${token}`;
};

export const fetchIndexesRequest = () => ({
  type: FETCH_INDEXES_REQUEST,
});

export const fetchIndexesSuccess = (value: IndexGroup[]) => ({
  type: FETCH_INDEXES_SUCCESS,
  payload: value,
});

export const fetchIndexesFailure = (error: any) => ({
  type: FETCH_INDEXES_FAILURE,
  payload: error,
});

export const setKeys = (keys: string[]) => ({
  type: SET_INDEXES,
  payload: keys,
});

export const setSelectedIndex = (value: any) => ({
  type: SET_SELECTED_INDEX,
  payload: value,
});

export const setSelectedSubIndex = (values: any[]) => ({
  type: SET_SELECTED_SUB_INDEX,
  payload: values,
});

export const setDefaultIndex = (value: any) => ({
  type: SET_DEFAULT_INDEXES,
  payload: value,
});

export const fetchAnnouncementsRequest = () => ({
  type: FETCH_ANNOUNCEMENTS_REQUEST,
});

export const fetchAnnouncementsSuccess = (value: any) => ({
  type: FETCH_ANNOUNCEMENTS_SUCCESS,
  payload: value,
});

export const fetchAnnouncementsFailure = (error: any) => ({
  type: FETCH_ANNOUNCEMENTS_FAILURE,
  payload: error,
});

export const setIndexKeyAndValue = (value: any) => ({
  type: SET_INDEX_KEY_AND_VALUE,
  payload: value,
});

export const toggleDeepSearchMode = () => ({
  type: SET_DEEPSEARCH_MODE,
});

export const setDeepSearchModeFalse = () => ({
  type: SET_DEEPSEARCH_MODE_FALSE,
});

export const toggleUseExternalDocumentsMode = () => ({
  type: SET_USE_ONLY_EXTERNAL_DOCUMENTS,
});

export const toggleUseExternalDocumentsModeFalse = () => ({
  type: SET_USE_ONLY_EXTERNAL_DOCUMENTS_FALSE,
});

export const updateHeaderIndexKeyAndValue = (searchIndexId: string) => ({
  type: UPDATE_HEADER_INDEX_KEY_AND_VALUE,
  payload: searchIndexId,
});

export const setExternalUploadedDocumentsCount = (count: number) => ({
  type: HAS_EXTERNAL_UPLOADED_DOCUMENTS,
  payload: count,
});

export const fetchIndexes = (token: any) => {
  return async (dispatch: Dispatch) => {
    if (token) {
      dispatch(fetchIndexesRequest());
      try {
        setAuthorizationHeader(token);
        const response = await thinkApi.get<IndexGroup[]>(
          "/conversation/indexes"
        );
        dispatch(fetchIndexesSuccess(response.data));
      } catch (error: any) {
        const appError = buildAppError(error, "");
        dispatch(fetchIndexesFailure(appError.message));
      }
    }
  };
};

export const fetchAnnouncements = (token: any) => {
  return async (dispatch: Dispatch) => {
    if (token) {
      dispatch(fetchAnnouncementsRequest());
      try {
        setAuthorizationHeader(token);
        const response = await thinkApi.get("conversation/announcements");
        dispatch(fetchAnnouncementsSuccess(response.data));
      } catch (error: any) {
        const appError = buildAppError(error, "");
        dispatch(fetchAnnouncementsFailure(appError.message));
      }
    }
  };
};
